import { Component } from 'preact';
import { Text } from 'preact-i18n';

export default class CameraRecording extends Component {
  state = { loading: true };
  stopped = false;

  componentDidMount() {
    this.loadRecording();
  }

  loadRecording = async () => {
    const base = `/api/v1/camera/${this.props.selector}/recording`;
    try {
      const job = await this.props.httpClient.post(base);
      if (job.status === 'busy') throw new Error('busy');
      const deadline = Date.now() + 180000;
      let result;
      do {
        if (this.stopped) return;
        result = await this.props.httpClient.get(`${base}/${job.id}`);
        if (result.status === 'error') throw new Error('unavailable');
        if (result.status !== 'ready') {
          if (Date.now() > deadline) throw new Error('timeout');
          await new Promise((resolve) => {
            this.delay = setTimeout(resolve, 1000);
            this.resume = resolve;
          });
        }
      } while (result.status !== 'ready');
      if (!Number.isSafeInteger(result.size) || result.size <= 0 || result.size > 34 * 1024 * 1024) {
        throw new Error('size');
      }
      const parts = [];
      let offset = 0;
      while (offset < result.size) {
        if (this.stopped) return;
        const chunk = await this.props.httpClient.get(`${base}/${job.id}/data`, { offset });
        if (chunk.next <= offset || chunk.next > result.size) throw new Error('chunk');
        const decoded = atob(chunk.data);
        parts.push(Uint8Array.from(decoded, (c) => c.charCodeAt(0)));
        offset = chunk.next;
      }
      if (this.stopped) return;
      this.blobUrl = URL.createObjectURL(new Blob(parts, { type: 'video/mp4' }));
      this.setState({ url: this.blobUrl, recordedAt: result.recorded_at, loading: false });
    } catch (error) {
      if (!this.stopped) this.setState({ error: true, loading: false });
    }
  }

  componentWillUnmount() {
    this.stopped = true;
    clearTimeout(this.delay);
    if (this.resume) this.resume();
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
  }

  render({ onClose }, { loading, error, url, recordedAt }) {
    return (
      <div class="p-3" aria-live="polite">
        {loading && (
          <p>
            <i class="fe fe-download mr-2" />
            <Text id="dashboard.boxes.camera.recordingLoading" />
          </p>
        )}
        {error && (
          <p class="alert alert-warning">
            <Text id="dashboard.boxes.camera.recordingError" />
          </p>
        )}
        {url && (
          <div>
            <p>
              <Text id="dashboard.boxes.camera.recordingDate" /> {new Date(recordedAt).toLocaleString()}
            </p>
            <video
              class="w-100"
              src={url}
              controls
              autoPlay
              playsInline
              onError={() => this.setState({ error: true })}
            />
          </div>
        )}
        <button class="btn btn-secondary btn-sm mt-2" onClick={onClose}>
          <Text id="dashboard.boxes.camera.recordingClose" />
        </button>
      </div>
    );
  }
}
